import React from 'react';
import Rodal from 'rodal';

const Notification = ({
                          openNotif,
                          config
                      }) => {

    return (
        <>
            <div className={"notification-container"}>
                <Rodal
                    visible={openNotif.show}
                    onClose={() => openNotif.setShow(false)}
                    animation={'door'}
                    width={60}
                    height={50}
                    measure={'%'}
                >
                    {
                        config && config.name &&
                        <div className={"notif-title"} style={{backgroundColor: config.color}}>
                            {config.name || 'Alerte'}
                        </div>
                    }
                    {config &&
                    <div className={'notif-icon'} style={{color: config.color || 'grey'}}>
                        <i className="fas fa-exclamation-triangle"/>
                    </div>}
                    {
                        config &&
                        config.message &&
                        <>
                            <div className={"notif-content"}>
                                {config.message}
                            </div>
                        </>
                    }
                </Rodal>
            </div>
        </>
    );
};

export default Notification;